export default [
  {
    path: "/zcfg",
    name: "zcfg",
    redirect: "/zcfg/index",
    meta: { title: "政策法规库" },
    component: () => import("@/layouts/PageLayouts.vue"),
    children: [
      {
        path: "/zcfg/index",
        name: "zcfg-index",
        component: () => import("@/views/zcfg/index.vue"),
        meta: { title: "政策法规库" },
      },
      {
        path: "/zcfg/detail",
        name: "zcfg-detail",
        component: () => import("@/views/zcfg/zcfg-detail/index.vue"),
        meta: { title: "政策法规" },
      },
    ],
  },
];